import React, { useState, useRef, useEffect, useCallback } from "react";
import { Tab, Tabs } from "@mui/material";
import Planning from "./Planning";
import Forecast from "./Forecast";
import Actuals from "./Actuals";
import Reports from "./Reports/Reports";
import Requests from "./Requests";
import FeedbackQr from "./FeedbackQr";

const TrainingDashboard = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  return (
    <>
      <div className="px-28 py-8">
        <h2 style={{ fontSize: "22px", fontWeight: "700" }}>Dashboard</h2>
      </div>
      <div className="px-28 pb-16">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          centered={true}
          textColor="inherit"
          sx={{ color: "yellow" }}
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1 border-white" }}
        >
          <Tab label="Planning" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="Forecast" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="Actuals" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="Reports" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="Requests" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="Feedback QR Code" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
        </Tabs>
      </div>
      <div className={tabValue !== 0 ? "hidden" : "h-full"}>
        <Planning />
      </div>
      <div className={tabValue !== 1 ? "hidden" : "h-full"}>
        <Forecast />
      </div>
      <div className={tabValue !== 2 ? "hidden" : "h-full"}>
        <Actuals />
      </div>
      <div className={tabValue !== 3 ? "hidden" : "h-full"}>
        <Reports />
      </div>
      <div className={tabValue !== 4 ? "hidden" : "h-full"}>
        <Requests />
      </div>
      <div className={tabValue !== 5 ? "hidden" : "h-full"}>
        <FeedbackQr />
      </div>
      {/* <div className={tabValue !== 4 ? 'hidden' : 'h-full'}>
                <Feed />
            </div> */}
    </>
  );
};
export default TrainingDashboard;
